<template>
  <b-container fluid class="px-sm-5 position-relative index-1">
    <b-row class="no-gutters mt-4 pb-4">
      <b-col col md="5" class="align-self-center">
        <img :src="logoIcon" class="not-logo mb-2" />
        <h4 class="color-white mb-4">
          Be part of the movement to democratise healthcare.
        </h4>
        <b-form @submit.prevent="submit">
          <b-form-group id="name-group" label-for="name">
            <b-form-input
              v-model="user.username"
              id="form_name"
              type="text"
              required
              placeholder="Please enter your email or mobile number"
              data-error="Email or mobile number is required."
            ></b-form-input>
          </b-form-group>
          <b-form-group id="email-group" label-for="email">
            <b-form-input
              v-model="user.password"
              id="form_password"
              type="password"
              required
              placeholder="Please enter your password"
            ></b-form-input>
          </b-form-group>
          <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
          <b-button :disabled="formStatus==='submitting'" type="submit" pill class="btn-yellow mb-4 px-5">Proceed</b-button>
        </b-form>
        <p class="color-white">
          <strong class="color-white d-block mb-2">CONTACT US</strong>Should you
          have any feedback, comments, requests for technical support or other
          inquiries, please contact us by email:
          <a href="mailto:info@envisionit.ai">info@envisionit.ai</a>.
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import logoIcon from '@/assets/images/logo.png'

export default {
  data () {
    return {
      logoIcon,
      formStatus: null,
      user: {
        username: null,
        password: null,
        recaptcha: null
      }
    }
  },
  computed: {
    ...mapState({
      status: state => state.auth.status,
      alert: state => state.alert
    })
  },
  created () {
    this.logout()
  },
  methods: {
    ...mapActions('auth', ['login', 'logout']),
    submit: function () {
      this.formStatus = 'submitting'
      this.user.username = this.user.username.toLowerCase()
      this.login(this.user)
    }
  },
  watch: {
    'user.username' (value) {
      this.formStatus = null
    },
    'user.password' (value) {
      this.formStatus = null
    }
  }
}
</script>
